// Hooks (@tanstack/react-query) imports
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { Store } from "./types";
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  store: Store;
  notificationID: string | number;
}

export function useUpdateStoreMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  const queryClient = useQueryClient();

  async function updateStore(variables: paramsType): Promise<any> {
    const response = await api.put<any>("admin/stores", variables.store);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updateStore,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(["Store", variables.store.id]);
      onSuccessMutation?.(data, variables);
    },
    onError: onErrorMutation,
  });
}
